import React, { Fragment, useEffect } from 'react'
import Card from '@mui/material/Card'
import { DataGridSettings } from '../../../interfaces/DataGrid/DataGridSettings'
import { DataGridColumn } from '../../DataGrid/DataGridColumn'
import { DataGridRowTreeView } from '../../DataGrid/DataGridRowTreeView'
import { CellText } from '../../DataGrid/CellText'
import { IconButton, Tooltip } from '@mui/material'
import ShareIcon from '@mui/icons-material/Share'
import { ContextMenu } from '../../ContextMenu/ContextMenu'
import { OtInbound } from '../../../interfaces/Planner/Planner'
import { TableOtInbound } from '../TableOtInbound'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'

interface GridElementOTInboundProps {
  element: OtInbound
  dataGridSettings: DataGridSettings
  isLoadingConfirm: boolean
  page: number
  pageSize: number
  handleGetOt: () => void
}

export const GridElementOTInbound: React.FC<GridElementOTInboundProps> = ({
  element,
  dataGridSettings,
  page,
  pageSize,
  handleGetOt
}) => {
  const { isPriority } = useSelector((state: RootState) => state.otInbound)

  const setPriority = () => {
    dataGridSettings.columns.forEach((e, index) => {
      if (e.dataField === 'priority') {
        dataGridSettings.columns[index].allowSorting = isPriority
      } else if (e.dataField === 'column-buttons') {
        dataGridSettings.columns[index].allowSorting = false
      } else {
        dataGridSettings.columns[index].allowSorting = !isPriority
      }
    })
  }

  useEffect(() => {
    setPriority()
  }, [isPriority])

  const date = new Date(`${element.createdAt}Z`)

  return (
    <Fragment>
      <Card>
        <div>
          <DataGridRowTreeView
            details={
              <TableOtInbound
                SupplierOriginName={element.supplierOriginName}
                UnitsQty={element.unitsQty}
                WorkOrderId={element.workOrderId}
                FEFO={element.fefo}
                SkuQty={element.skuQty}
                SkuPriorityQty={element.skuPriorityQty}
                UnitsPriorityQty={element.unitsPriorityQty}
              />
            }
            onClick={() => console.log()}
            loading={false}
          >
            <DataGridColumn datafield='priority' settings={dataGridSettings}>
              {isPriority && Math.floor(element.rowNum)}
              <ContextMenu
                handleGetOt={handleGetOt}
                workId={element.workOrderId}
                page={page}
                pageSize={pageSize}
              />
            </DataGridColumn>

            <DataGridColumn
              datafield='workOrderCode'
              settings={dataGridSettings}
            >
              <CellText text={element.workOrderCode} textAlign={true} />
            </DataGridColumn>

            <DataGridColumn datafield='asnNumber' settings={dataGridSettings}>
              <CellText text={element.asnNumber} />
            </DataGridColumn>
            <DataGridColumn datafield='CreatedAt' settings={dataGridSettings}>
              <div style={{ marginLeft: '20px' }}>
                <CellText text={date.toLocaleString()} />
              </div>
            </DataGridColumn>
            <DataGridColumn
              datafield='SupplierName'
              settings={dataGridSettings}
            >
              <div style={{ textAlign: 'center' }}>
                <CellText text={element.supplierName} />
              </div>
            </DataGridColumn>

            <DataGridColumn
              datafield='asnStateName'
              settings={dataGridSettings}
            >
              <div style={{ textAlign: 'center' }}>
                <CellText text={element.asnStateName} />
              </div>
            </DataGridColumn>

            <DataGridColumn
              datafield='column-buttons'
              settings={dataGridSettings}
            >
              <Tooltip title='OT hij@s: OT456' aria-label='edit'>
                <IconButton disabled={true} aria-label='edit'>
                  <ShareIcon />
                </IconButton>
              </Tooltip>
            </DataGridColumn>
          </DataGridRowTreeView>
        </div>
      </Card>
    </Fragment>
  )
}
